import { Analytics } from '@cobliteam/analytics/src/Analytics';
import { Drawer, DrawerBody, DrawerContent, DrawerTitle, DrawerTrigger } from '@cobliteam/ui/components';
import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import AppInfo from '../../../../../../AppInfo/AppInfo';
import ShineBorder from '../../../../../../border/ShineBorder';

const DrawerPageInfo = ({ supportUID }: { supportUID: string }) => {
  const onButtonClick = () => {
    Analytics.track('Page Info - Button Clicked', { supportUID });
  };

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <div className='relative overflow-hidden rounded-md'>
          <ShineBorder shineColor={['#E0E0E0', '#E0E0E0', '#A07CFE', '#FE8FB5', '#FFBE7B', '#E0E0E0']} borderWidth={2} />
          <Button variant='ghost' icon={<Icon name='info' />} color='default' size='sm' className='relative overflow-hidden' onClick={onButtonClick} />
        </div>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerBody className='flex h-full flex-1 flex-col px-0 py-2'>
          <DrawerTitle className='hidden' />
          <AppInfo supportUID={supportUID} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default DrawerPageInfo;
